module.exports = __webpack_public_path__ + "static/media/1.f91be023.JPG";